export enum WorldpayIntegrationType {
  Iframe = 'iframe',
  Lightbox = 'lightbox',
}
